export default "__VITE_ASSET__BGT9RM61__"